





















import Vue from "vue";

export default Vue.extend({
  name: "PointerMenu",
  props: {
    size: String,
    inline: Boolean,
    blackIcon: Boolean,
  },
  data() {
    return {
      showRight: false as boolean,
      maxWidth: null as number | null,
    };
  },
  methods: {
    calcPosition(e: any) {
      var windowWidth = window.innerWidth;
      var menuPosLeft = e.target.getBoundingClientRect().left;

      if (menuPosLeft > windowWidth * 0.5) {
        this.showRight = true;
      } else {
        this.showRight = false;

        var diffWidth = windowWidth - menuPosLeft - 35;

        if (diffWidth < 280) {
          this.maxWidth = diffWidth;
        } else {
          this.maxWidth = null;
        }
      }
    },
  },
  computed: {},
});
